import { combineReducers } from "redux";
import user from "./user";
import alerts from "./alerts";
import session from "./session";

const rootReducer = combineReducers({
  session,
  user,
  alerts,
});

export default rootReducer;
